export default __webpack_public_path__ + "static/media/play-button-arrowhead.999e66cd.svg";